"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texInputConfig = void 0;
require("mathjax-full/js/input/tex/ams/AmsConfiguration");
require("mathjax-full/js/input/tex/boldsymbol/BoldsymbolConfiguration");
require("mathjax-full/js/input/tex/cancel/CancelConfiguration");
require("mathjax-full/js/input/tex/color/ColorConfiguration");
require("mathjax-full/js/input/tex/configmacros/ConfigMacrosConfiguration");
require("mathjax-full/js/input/tex/enclose/EncloseConfiguration");
require("mathjax-full/js/input/tex/gensymb/GensymbConfiguration");
require("mathjax-full/js/input/tex/mathtools/MathtoolsConfiguration");
require("mathjax-full/js/input/tex/mhchem/MhchemConfiguration");
require("mathjax-full/js/input/tex/noerrors/NoErrorsConfiguration");
require("mathjax-full/js/input/tex/noundefined/NoUndefinedConfiguration");
require("mathjax-full/js/input/tex/textmacros/TextMacrosConfiguration");
require("mathjax-full/js/input/tex/unicode/UnicodeConfiguration");
require("./memory-leak-fix");
const blue = "3D7586";
const green = "447A53";
const gray = "5D5F66";
const grayH = "3B3D45";
const grayI = "21242C";
const purple = "594094";
const purpleD = "8351E8";
const pink = "B25071";
const gold = "946700";
const red = "D92916";
function colorMacro(hexCode) {
    return [`{\\color{##${hexCode}}#1}`, 1];
}
exports.texInputConfig = {
    packages: [
        "base",
        // NOTE: Use of the packages below requires importing the
        // corresponding configuration file from
        // mathjax-full/js/input/tex/*/*Configuration. Those imports
        // are above.
        // AMS includes the control sequences listed here:
        // https://docs.mathjax.org/en/latest/input/tex/extensions/ams.html#tex-ams-commands
        // For the full list of available packages, see:
        // https://docs.mathjax.org/en/latest/input/tex/extensions/index.html
        "ams",
        "boldsymbol",
        "cancel",
        "color",
        "configmacros",
        "enclose",
        "gensymb",
        "mathtools",
        "mhchem",
        "noerrors",
        "noundefined",
        "textmacros",
        "unicode",
    ],
    // NOTE: Using the `macros` option requires specifying the
    // "configmacros" package in `packages`, above!
    macros: {
        AA: "Å",
        isin: ["\\in"],
        infin: ["\\infty"],
        inte: ["\\int"],
        footnotesize: ["\\small"],
        arccos: ["\\operatorname{arccos}"],
        arcctg: ["\\operatorname{arcctg}"],
        arctg: ["\\operatorname{arctg}"],
        cosec: ["\\operatorname{cosec}"],
        cossec: ["\\operatorname{cossec}"],
        cotg: ["\\operatorname{cotg}"],
        ctg: ["\\operatorname{ctg}"],
        sen: ["\\operatorname{sen}"],
        tg: ["\\operatorname{tg}"],
        lcm: ["\\operatorname{lcm}"],
        bm: "\\boldsymbol",
        bold: "\\mathbf",
        Complex: "\\mathbb{C}",
        N: "\\mathbb{N}",
        R: "\\mathbb{R}",
        RR: "\\mathbb{R}",
        Z: "\\mathbb{Z}",
        gcf: ["\\mathop{\\rm gcf}"],
        mathellipsis: "\\dots",
        oiint: "\\mathop{\\unicode{x222F}}",
        overgroup: "\\overparen",
        pounds: "\\unicode{x00a3}",
        thickspace: "\\;",
        rarr: "\\rightarrow",
        rArr: "\\Rightarrow",
        ratio: "\\centercolon",
        Alpha: "\\unicode{x0391}",
        Beta: "\\unicode{x0392}",
        Epsilon: "\\unicode{x0395}",
        Zeta: "\\unicode{x0396}",
        Eta: "\\unicode{x0397}",
        Iota: "\\unicode{x0399}",
        Kappa: "\\unicode{x039A}",
        Mu: "\\unicode{x039C}",
        Nu: "\\unicode{x039D}",
        Omicron: "\\unicode{x039F}",
        Rho: "\\unicode{x03A1}",
        Tau: "\\unicode{x03A4}",
        Chi: "\\unicode{x03A7}",
        // Using \vphantom{j} here ensures that the bounding box of the
        // struck-out content accommodates characters with descenders.
        // This centers the stroke vertically on lowercase text.
        // The \! negative spaces are needed because \enclose adds
        // horizontal space, which isn't suitable for e.g. striking out
        // part of a word.
        sout: ["\\enclose{horizontalstrike}{\\!\\vphantom{j}#1\\!}", 1],
        sube: "\\subseteq",
        def: "",
        arraystretch: ["", 1],
        // Map \1, \2, etc. to 1, 2...
        // This works around a common typo that gets introduced during
        // translation. When `\$1` gets localized to another currency,
        // translators sometimes remove the dollar sign but not the backslash.
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        blue: colorMacro(blue),
        orange: colorMacro(gold),
        pink: colorMacro(pink),
        red: colorMacro(red),
        green: colorMacro(green),
        gray: colorMacro(gray),
        purple: colorMacro(purple),
        blueA: colorMacro(blue),
        blueB: colorMacro(blue),
        blueC: colorMacro(blue),
        blueD: colorMacro(blue),
        blueE: colorMacro(blue),
        tealA: colorMacro(green),
        tealB: colorMacro(green),
        tealC: colorMacro(green),
        tealD: colorMacro(green),
        tealE: colorMacro(green),
        greenA: colorMacro(green),
        greenB: colorMacro(green),
        greenC: colorMacro(green),
        greenD: colorMacro(green),
        greenE: colorMacro(green),
        goldA: colorMacro(gold),
        goldB: colorMacro(gold),
        goldC: colorMacro(gold),
        goldD: colorMacro(gold),
        goldE: colorMacro(gold),
        redA: colorMacro(red),
        redB: colorMacro(red),
        redC: colorMacro(red),
        redD: colorMacro(red),
        redE: colorMacro(red),
        maroonA: colorMacro(pink),
        maroonB: colorMacro(pink),
        maroonC: colorMacro(pink),
        maroonD: colorMacro(pink),
        maroonE: colorMacro(pink),
        purpleA: colorMacro(purpleD),
        purpleB: colorMacro(purpleD),
        purpleC: colorMacro(purpleD),
        purpleD: colorMacro(purpleD),
        purpleE: colorMacro(purple),
        grayA: colorMacro(gray),
        grayB: colorMacro(gray),
        grayC: colorMacro(gray),
        grayD: colorMacro(gray),
        grayE: colorMacro(gray),
        grayF: colorMacro(gray),
        grayG: colorMacro(gray),
        grayH: colorMacro(grayH),
        grayI: colorMacro(grayI),
        // kaBlue, kaGreen, and the mint variants are deprecated colors, very
        // rarely used
        kaBlue: colorMacro("314453"),
        kaGreen: colorMacro("71B307"),
        mintA: colorMacro("F5F9E8"),
        mintB: colorMacro("EDF2DF"),
        mintC: colorMacro("E0E5CC"),
        // For rational exponents, we provide \^ instead of ^ which pushes
        // the exponent up higher, so it's really clear that the fraction
        // is an exponent. The measurement of 0.75em was chosen to make the
        // layout the same as the old KaTeX version of this macro,
        // {}^{^{^{#1}}}
        "^": ["^{\\raise{0.75em}{\\scriptscriptstyle #1}}", 1],
    },
    environments: {
        darray: ["{\\displaystyle\\begin{array}", "\\end{array}}"],
    },
};
